import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useNavigate} from 'react-router-dom'
import useApi from '../../utility/Hooks/Api/useApi';
import {VehicleApi} from '../../services/Api/VehicleApi';
import { CompanyApi } from '../../services/Api/CompanyApi';
import DefaultTable from '../../components/Tables/Bodies/DefaultTable';
import FunctionalTableHeader from '../../components/Tables/Headers/FunctionalTableHeader';
import ConfirmationModal from "../../components/Modals/ConfirmationModal";
import ExportButton from '../../features/export/ExportButton';
import { vehiclesExportConfig } from '../../features/export/exportConfigs/vehiclesExportConfig';

export default function VehiclesView() {
    const itemEls = useRef([]);
    const {request, data} = useApi();
    const {request: companyRequest, data: companyData} = useApi();
    const {request: deleteRequest, loading, data: deleteData, error: deleteError, reset: deleteReset} = useApi();
    const navigate = useNavigate();
    const [checkItems, setCheckItems] = useState([]);
    const [modalHidden, setModalHidden] = useState(false);
    const [q, setQ] = useState("");
    const [searchParam] = useState([
        "id",
        "Reference",
        "Owner",
        "Type",
        "Category",
        "Brand",
        "Model",
        "NumberPlate",
        "NumberPlateCountry",
    ]);

    useEffect(() => {
        request(VehicleApi.getVehicles());
        companyRequest(CompanyApi.getCompanies())
        if (deleteData) {
            itemEls.current = [];
            setCheckItems([...itemEls.current])
        }
    }, [deleteRequest]);

    const column = [
        // {heading: 'ID', value: 'id',},
        {heading: 'Reference', value: 'Reference',},
        {heading: 'Owner', value: 'Owner',},
        {heading: 'Type', value: 'Type',},
        {heading: 'Category', value: 'Category',},
        {heading: 'Brand', value: 'Brand',},
        {heading: 'Model', value: 'Model',},
        {heading: 'Number Plate', value: 'NumberPlate',},
        {heading: 'Country', value: 'NumberPlateCountry',},
    ];

    const deletionHandler = (ele) => {
        const id = itemEls.current.find(function (element) {
            return element === ele["id"];
        });

        if (!id) {
            itemEls.current.push(ele["id"]);
            return setCheckItems([...itemEls.current])
        } else {
            const filtered = checkItems.filter(id => {
                return id !== ele["id"];
            });
            itemEls.current = [...filtered];
            return setCheckItems([...itemEls.current])
        }
    };

    const deleteRequestHandler = () => {
        checkItems.map((e) => {
            deleteRequest(VehicleApi.deleteVehicle(e))
        });
        itemEls.current = [];
        setCheckItems([...itemEls.current])
    };

    const modalHandler = () => {
        setModalHidden(!modalHidden);
        if (!modalHidden) {
            deleteReset();
        }
    };

    const deletionCondition = checkItems.length > 0;

    const getCaseInsensitive = (obj, key) => {
        if (!obj) return undefined;
        const lowerCaseKey = key.toLowerCase();
        return Object.keys(obj).reduce((result, currentKey) => {
            return currentKey.toLowerCase() === lowerCaseKey ? obj[currentKey] : result;
        }, undefined);
    };

    const searchHandler = (items) => {
        if (!items || !companyData) return null;
        const normalizedQuery = q.toLowerCase();
        
        // Find all company IDs where the company name matches the query
        const matchingCompanyIds = companyData
            .filter((company) => company["company name"]?.toLowerCase().indexOf(normalizedQuery) > -1)
            .map((company) => company["customer id"].toString()); // Get IDs of matching companies
    
        return items?.filter((item) => {
            return searchParam.some((field) => {
                // Normalize field names to lower case for case-insensitive comparison
                const normalizedField = field.toLowerCase();
                
                // Handle nested field search (e.g., "parent.child")
                if (normalizedField.includes(".")) {
                    const [parent, child] = normalizedField.split(".");
                    return (
                        item[parent]?.[child]
                            ?.toString()
                            ?.toLowerCase()
                            ?.indexOf(normalizedQuery) > -1
                    );
                } else if (["Owner"].includes(field)) {
                    // Check if the field matches any of the company IDs
                    return matchingCompanyIds.includes( getCaseInsensitive(item, normalizedField)?.toString());
                } else {
                    // Standard string matching for other fields (case-insensitive)
                    return (
                        getCaseInsensitive(item, normalizedField)?.toString()?.toLowerCase()?.indexOf(normalizedQuery) > -1
                    );
                }
            });
        });
    };
    
    const currentTableData = useMemo(() => {
        return searchHandler(data)
    }, [data, companyData, q]);

    return (
        <>
            <div className="relative container mx-auto shadow-2xl bg-white rounded-lg min-h-[46.4rem]">
                    <ConfirmationModal hidden={modalHidden} onCancelClick={() => modalHandler(!modalHidden)}
                                       loading={loading} onClick={() => deleteRequestHandler()} error={deleteError}
                                   data={deleteData}/>
                <FunctionalTableHeader
                    title={"Vehicles"}
                    onClick={deletionCondition ? () => modalHandler() : null}
                    onClickAdd={() => navigate("/main/vehicle/add")}
                    onDelete={deletionCondition}
                    onChange={(e) => setQ(e.target.value)}
                    exportButton={<ExportButton config={vehiclesExportConfig} data={data} companyData={companyData} />}/>
                <DefaultTable
                    companyIdKey={["owner"]}
                    data={currentTableData}
                    column={column} onChange={(e) => deletionHandler(e)} deletionItems={checkItems}
                    onNavDetail="/main/vehicle/"
                    checkBox
                    pageType="vehicles"/>
            </div>
        </>
    )
}